var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
export class ReminderUserFullSizeDto {
    id;
    createdAt;
    updatedAt;
    strapiId;
    userId;
    user;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ReminderUserFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ReminderUserFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ReminderUserFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ReminderUserFullSizeDto.prototype, "strapiId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ReminderUserFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], ReminderUserFullSizeDto.prototype, "user", void 0);
//# sourceMappingURL=reminder-user.full-size-dto.js.map